import { PrescriptionService } from '@/services/prescription.service';
export default {
  props: {
    prescriptionData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      showDialog: false,
      alert: {
        show: false,
        message: ''
      },
      processing: false
    };
  },
  methods: {
    showAlert(msg) {
      this.alert.show = true;
      this.alert.message = msg;
    },
    async onScheduledPrescriptionPush() {
      this.alert.show = false;
      try {
        this.processing = true;
        await PrescriptionService.pushScheduledPrescription(this.prescriptionData.patientid, this.prescriptionData.id);
        setTimeout(() => {
          this.$emit('refresh-prescriptions', 'push-scheduled-prescription');
        }, 3000);
        this.processing = false;
        this.showDialog = false;
      } catch (err) {
        this.showAlert(err);
        this.processing = false;
      }
    }
  }
};